import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Users, Trophy } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JoinTournament() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [info, setInfo] = useState(null);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/tournaments/invite/${code}`);
        setInfo(r.data);
      } catch { toast.error("Invalid invite"); }
    })();
  }, [code]);

  const join = async () => {
    if (!user) {
      sessionStorage.setItem("pending_join", info.tournament_id);
      navigate("/auth?mode=register");
      return;
    }
    setJoining(true);
    try {
      await api.post(`/tournaments/${info.tournament_id}/join`);
      toast.success("Joined!");
      navigate(`/tournament/${info.tournament_id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not join");
    } finally {
      setJoining(false);
    }
  };

  if (!info) return <div className="min-h-screen bg-slate-950"><Nav /><div className="p-10 text-slate-500">Loading invite…</div></div>;

  return (
    <div className="min-h-screen bg-slate-950">
      <Nav />
      <div className="max-w-2xl mx-auto px-6 py-16">
        <div className="text-xs text-amber-400 font-mono-data tracking-widest">TOURNAMENT INVITE</div>
        <h1 className="mt-3 text-4xl md:text-5xl font-bold text-slate-50">{info.name}</h1>
        {info.game_name && <p className="mt-2 text-slate-400 font-mono-data uppercase text-sm tracking-wider">{info.game_name}</p>}
        {info.description && <p className="mt-4 text-slate-300">{info.description}</p>}

        <div className="mt-8 grid grid-cols-2 gap-4">
          <div className="rounded-xl border border-white/10 bg-slate-900/50 p-5">
            <div className="text-xs text-slate-500 font-mono-data tracking-widest">ORGANIZER</div>
            <div className="mt-2 text-slate-100">{info.organizer_name}</div>
          </div>
          <div className="rounded-xl border border-white/10 bg-slate-900/50 p-5">
            <div className="text-xs text-slate-500 font-mono-data tracking-widest">PLAYERS</div>
            <div className="mt-2 text-slate-100 font-mono-data">{info.current_players} / {info.total_players}</div>
          </div>
        </div>

        <div className="mt-8">
          <Button size="lg" onClick={join} disabled={joining || info.status !== "open"} className="w-full h-14 bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="join-invite-submit">
            {info.status !== "open" ? "Tournament already started" : joining ? "Joining…" : user ? "Join Tournament" : "Sign up to Join"}
          </Button>
        </div>
      </div>
    </div>
  );
}
